import { render, staticRenderFns } from "./questionTypeCard.vue?vue&type=template&id=fe98933e&scoped=true&"
import script from "./questionTypeCard.vue?vue&type=script&lang=js&"
export * from "./questionTypeCard.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeCard.vue?vue&type=style&index=0&id=fe98933e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe98933e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
